import React from "react";
import { Link } from "react-router-dom";
import "./component.css";

const Component = () => {
  return (
    <div className="not-found-page  d-flex flex-column justify-content-center align-items-center vh-100 text-center">
      <h1 className="display-1 text-danger fw-bold">404</h1>
      <p className="fs-4 mb-4">Oops! The page you're looking for doesn't exist.</p>
      <Link to="/" className="btn btn-primary">Go Back Home</Link>
    </div>
  );
};

export default Component;
